var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAenaCat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 108.12 103.23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#1a2732"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.56,65.47h-7c-2.32,0-3.77,2.51-2.61,4.52l3.5,6.06c1.16,2.01,4.06,2.01,5.22,0l3.5-6.06c1.16-2.01-.29-4.52-2.61-4.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.92,50.97h-7.53c-1.33,0-2.4,1.07-2.4,2.4v6.38c0,1.32,1.07,2.4,2.4,2.4h7.53c1.33,0,2.4-1.08,2.4-2.4v-6.38c0-1.33-1.08-2.4-2.4-2.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.74,50.97h-7.53c-1.33,0-2.4,1.07-2.4,2.4v6.38c0,1.32,1.07,2.4,2.4,2.4h7.53c1.33,0,2.4-1.08,2.4-2.4v-6.38c-.01-1.33-1.08-2.4-2.4-2.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.39.73c-3.53-1.47-7.41-.7-10.12,2-.05.05-.1.1-.15.16l-11.34,12.9c-4.19-2.79-13.19-7.5-26.56-7.55h-.32c-13.36.05-22.37,4.76-26.56,7.55L16,2.89s-.1-.11-.15-.16C13.14.03,9.26-.74,5.73.73,2.19,2.2,0,5.49,0,9.31v47.39c0,27.78,21.68,46.45,53.97,46.53h.18c32.29-.07,53.97-18.75,53.97-46.53V9.32c0-3.83-2.2-7.12-5.73-8.59ZM101.62,56.7c0,12.24-4.75,22.47-13.72,29.59-8.47,6.72-20.48,10.42-33.84,10.44h0c-13.36-.02-25.37-3.72-33.83-10.44-8.98-7.12-13.72-17.36-13.72-29.59V9.32c0-1.73,1.32-2.41,1.72-2.58.4-.17,1.77-.6,2.98.54l13.23,15.06c.57.65,1.39,1.05,2.25,1.1.87.05,1.72-.25,2.37-.83.08-.07,9.01-7.82,25-7.85,15.99.03,24.92,7.78,25,7.85.64.58,1.5.88,2.37.83s1.68-.45,2.25-1.1l13.23-15.06c1.21-1.14,2.58-.7,2.98-.54.4.17,1.72.85,1.72,2.58v47.38h0Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAenaCat);
export default __webpack_public_path__ + "static/media/aena_cat.8cf6c4e89251512bdf47cb16b7334868.svg";
export { ForwardRef as ReactComponent };